import { IFacilityData } from "../administration/facilityData";
import { IPicklistValuesData } from "../administration/picklistValuesData";
import { IUserData } from "../administration/userData";
import { ICarryoverComments } from "./firedepartmentCarryoverComments";

export interface IFireDepartmentBcTurnover {
  id: number;
  facilityId: number;
  facilityName: string;
  facility: IFacilityData;
  status?: TurnoverStatus;
  turnoverCategory: TurnoverCategory;
  subCategory?: SubCatgory; // only added if category is FirewaterPumpLeak
  turnoverDate: Date;
  resolvedDate?: Date;
  initialComments: string;
  resolvedComments: string;
  crewId: number;
  shiftId: number;
  categoryId: number;
  pumpStatus: PumpStatus;
  pumpId: number;
  selectedValuesInTurnover: IPicklistValuesData[];
  carryoverComments?: ICarryoverComments[];
  category: string;
  shift: string;
  crew: string;
  createdBy?: IUserData;
  createdById?: number;
  modifiedBy?: IUserData;
  modifiedById?: number;
  createdDate: Date;
  modifiedDate?: Date;
  comments?: string;
}

export enum TurnoverStatus {
  Open = 0,
  Resolved = 1,
}

export enum TurnoverCategory {
  "Firewater - Pump/Leak" = 0,
  "Miscellaneous" = 1,
  "Safety/Security" = 2,
  "Equipment" = 3,
  "Incident/Personnel" = 4,
}

export enum SubCatgory {
  Pump = 0,
  Leak = 1,
}

export enum PumpStatus {
  Available = 0,
  Offline = 1,
  "Mechanical Issue" = 2,
}
